import "../../CommonImports";
import "../../Core/core.css";
import "./SingleLayerMasterPanel.css";
import * as React from "react";
import { useObservable } from '../../Core/Observable';
import { Header } from '../../Header';
import { Intersection } from '../../Intersection';
import { Observer } from '../../Observer';
import { css } from '../../Util';
/**
 * Props-controlled implementation of MasterPanel for experiences that don't need the layering of MasterDetailsContext
 */
export var SingleLayerMasterPanel = function (props) {
    var className = props.className, renderContent = props.renderContent, renderHeader = props.renderHeader, renderSearch = props.renderSearch, _a = props.showOnSmallScreens, showOnSmallScreens = _a === void 0 ? false : _a;
    var _b = useObservable(false), isScrolled = _b[0], setIsScrolled = _b[1];
    var contentElement = React.useRef(null);
    var onContentScroll = function () {
        if (contentElement.current) {
            if (contentElement.current.scrollTop === 0) {
                setIsScrolled(false);
            }
            else {
                setIsScrolled(true);
            }
        }
    };
    return (React.createElement(Intersection, null,
        React.createElement("div", { className: css(className, "bolt-master-panel flex-column flex-noshrink scroll-auto", showOnSmallScreens && "show-on-small-screens"), onScroll: onContentScroll, ref: contentElement },
            renderHeader && (React.createElement(Observer, { isScrolled: isScrolled }, function (observerProps) { return (React.createElement("div", { className: css("bolt-master-panel-header", renderSearch && "has-search", observerProps.isScrolled && "content-scrolled") }, renderHeader())); })),
            React.createElement("div", { className: "bolt-master-panel-content flex-column" },
                renderSearch && React.createElement("div", { className: "bolt-master-panel-search" }, renderSearch()),
                renderContent && renderContent()))));
};
export var SingleLayerMasterPanelHeader = function (props) {
    var title = props.title, subTitle = props.subTitle, onBackButtonClick = props.onBackButtonClick;
    return (React.createElement(Header, { backButtonProps: onBackButtonClick
            ? {
                onClick: onBackButtonClick,
                subtle: true
            }
            : undefined, className: "bolt-master-panel-standard-header", description: subTitle, descriptionClassName: "bolt-master-panel-header-subtitle bolt-master-panel-header-secondary", title: title, titleClassName: "bolt-master-panel-header-title", titleSize: 1 /* Large */ }));
};
